import { render, staticRenderFns } from "./bottomGzsbwx.vue?vue&type=template&id=09ee67c4&scoped=true"
import script from "./bottomGzsbwx.vue?vue&type=script&lang=js"
export * from "./bottomGzsbwx.vue?vue&type=script&lang=js"
import style0 from "./bottomGzsbwx.vue?vue&type=style&index=0&id=09ee67c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee67c4",
  null
  
)

export default component.exports